import React from 'react';
import { useSidebarState } from 'react-admin';

/** Kapalı sidebar'da bölüm başlıklarını tamamen kaldırır. */
const SidebarSectionTitle = ({ children }) => {
  const [open] = useSidebarState();
  if (!open) return null;

  return (
    <h5
      className="sidebar-section-title"
      style={{
        marginLeft: 10,
        marginRight: 10,
        marginTop: 12,
        marginBottom: 5,
        borderBottom: '1px solid #EEE',
        fontWeight: 300,
        paddingBottom: 5,
        fontSize: 12,
        color: '#666',
      }}
    >
      {children}
    </h5>
  );
};

export default SidebarSectionTitle;
